<router-outlet></router-outlet>
<app-modal-container></app-modal-container>
<app-loader></app-loader>
<app-countdown></app-countdown>
